import { css } from '@emotion/css';

import { colors } from '@ajaibid/components';

const { NEUTRAL_0 } = colors;

export const styRightPanel = css`
  position: absolute;
  width: 320px;
  inset: 0% 0% 0% calc(100% - 324px); // RightPanel size 320px, margin 4px
  margin: 4px 2px 0px 2px;
  background: ${NEUTRAL_0};
  border-radius: 4px;
  overflow: auto;
`;
